import { useState } from "react";
import { authStore } from "../../App";
import { Box, Button, TextField } from "@mui/material";
import { Column } from "primereact/column";
import { Col, Row } from "react-bootstrap";
import ArcadeSticker from "../../Assets/Icons/arcade-game.png";
import { RegisterDialog } from "./registerDialog";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase";
import { Label } from "@mui/icons-material";

const LoginScreen: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const attemptLogin = () => {
    setLoading(true);
    signInWithEmailAndPassword(auth, email, password)
      .then((account) => {
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(
          "Failed to login. Please verify your email address and password combination."
        );
      });
  };

  return (
    <div style={css}>
      <div
        style={{
          margin: "auto auto",
          display: "flex",
          flexFlow: "column",
          background: "whitesmoke",
          textAlign: "center",
        }}
      >
        <Row
          sx={12}
          m={12}
          lg={12}
          style={{ display: "flex", flexFlow: "row", padding: 50 }}
        >
          <Col sm={6} md={6} lg={6}>
            <Box>
              <img src={ArcadeSticker} width={500} />
            </Box>
          </Col>
          <Col
            sm={6}
            md={6}
            lg={6}
            style={{
              display: "flex",
              flexFlow: "column",
              justifyContent: "center",
              background: "white",
            }}
          >
            <div style={{ padding: 100, columnGap: 35 }}>
              <TextField
                fullWidth
                required
                id="outlined-required"
                label="Email"
                defaultValue="riaz@gmail.com"
                onChange={(e) => setEmail(e.target.value)}
                style={{ width: "100%" }}
              />

              <TextField
                required
                id="outlined-required"
                label="Password"
                defaultValue="Huambo#1995"
                type="password"
                style={{ width: "100%" }}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div style={{ padding: 10 }}>
                {error ? (
                  <label style={{ color: "tomato" }}>{error}</label>
                ) : (
                  <label>{""}</label>
                )}
              </div>
              <Button
                onClick={() => attemptLogin()}
                variant="contained"
                style={{ width: "100%" }}
              >
                {loading ? "Loading" : "Login"}
              </Button>
              <RegisterDialog />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const css = {
  display: "flex",
  flexFlow: "column",
  width: "100vw",
  height: "100vh",
  background: "tomato",
} as React.CSSProperties;

export default LoginScreen;
